module.exports = __webpack_public_path__ + "static/media/5-Thuiskok-foto2.a17a10bf.jpg";